import { GET } from "./CRUDService";

const DownloadFile = async (downloadZipUrl, transaction_id) => {
  const urlWithParams = `${downloadZipUrl}${transaction_id}`;

  try {
    const response = await GET(urlWithParams); // GET request to get binary content

    if (response.ok) {
      const blob = await response.blob(); // Get blob from response
      let filename = `Certificate_${transaction_id}`;
      const contentDisposition = response.headers.get("Content-Disposition");
      console.log("contentDisposition : ", contentDisposition);
      const contentType = response.headers.get("Content-Type");
      console.log("contentType : ", contentType);

      // Extract filename from Content-Disposition header if available
      if (contentDisposition && contentDisposition.includes("filename=")) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        console.log("match>>>>>>", match);
        if (match && match[1]) {
          filename = match[1];
        }
      } else {
        // Set file extension based on Content-Type if filename not provided
        if (contentType === "application/zip") {
          filename += ".zip";
        } else if (contentType === "image/png") {
          filename += ".png";
        }
      }
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      console.log("File name in link.download >>>>> ", link.download);
      document.body.appendChild(link);

      // Simulate user click event
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } else {
      console.error("Error fetching the file:", response.statusText);
    }
  } catch (error) {
    console.error("Error Downloading file:", error);
  }
};

export default DownloadFile;
